import moment from 'moment';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'GiftTracker',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.loginDetails || this.loginDetails.userType != 1) {
            this.logout();
            return;
        }
        this.GetSummary();
        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null || date === undefined) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            From: '',
            To: '',
            ScreenTitle: 'تتبع رصيد الهدية',
            activeTab: 'charges',
            Info: [],
            Statistics: {}
        };
    },

    methods: {
        ChangeTab(tab) {
            this.activeTab = tab;
            this.pageNo = 1;
            this.GetInfo();
        },

        GetSummary() {
            const from = this.From ? this.ChangeDate(this.From) : '';
            const to = this.To ? this.ChangeDate(this.To) : '';
            this.$http.GetGiftSummary(from, to)
                .then(response => {
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => { this.Statistics = {}; });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            if (this.From)
                this.From = this.ChangeDate(this.From);
            if (this.To)
                this.To = this.ChangeDate(this.To);

            this.$blockUI.Start();
            let request;
            if (this.activeTab === 'charges') {
                request = this.$http.GetGiftCharges(this.pageNo, this.pageSize, this.Search, this.From, this.To);
            } else if (this.activeTab === 'purchases') {
                request = this.$http.GetGiftPurchases(this.pageNo, this.pageSize, this.Search, this.From, this.To);
            } else {
                request = this.$http.GetGiftBalances(this.pageNo, this.pageSize, this.Search);
            }

            request.then(response => {
                this.$blockUI.Stop();
                this.Info = response.data.info || [];
                this.pages = response.data.count || 0;
                this.GetSummary();
            }).catch(() => {
                this.$blockUI.Stop();
                this.Info = [];
                this.pages = 0;
            });
        }
    }
};
